import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export async function uploadFile(
  file,
  associatedWith,
  bucket,
  principal_id,
  uploadProgress = () => {}
) {
  const headers = getTokenHeader();
  const token = env.file_client_token;

  const formData = new FormData();

  formData.append("bucket", bucket);
  formData.append("associateWith", associatedWith);
  formData.append("principal_id", principal_id);
  if (file.filename) {
    // filename for blobs
    formData.append("file", file, file.filename);
  } else {
    formData.append("file", file);
  }

  const res = await axios.post(
    `${env.file_client_url}v1/file/create`,
    formData,
    {
      params: { token, bucket: bucket },
      headers,
      onUploadProgress: uploadProgress
    }
  );
  const obj = res?.data?.data;

  return {
    id: obj._id,
    url: obj.url,
    locked: obj.locked,
    title: obj.title
  };
}

export async function updateLockingFile(fileId, fileUrl, locked) {
  const headers = getTokenHeader();
  const token = env.file_client_token;

  const res = await axios.put(
    `${env.file_client_url}v1/file/update`,
    {
      locked
    },
    {
      params: { token, id: fileId, url: fileUrl },
      headers
    }
  );

  return res?.data;
}
